import { useStore } from 'jotai'
import { useCallback } from 'react'

import { waitForQuoteSyncIdle } from './waitForQuoteSyncIdle'

/**
 * Hands back a wait that anything sending the quote out - publishing, mostly -
 * has to get through first, or the server acts on the version before the user's
 * last edit.
 *
 * Must be called below `QuoteSyncProvider`, or it reads a status nothing writes
 * and the wait is over before it starts.
 */
export const useWaitForQuoteSyncIdle = (): (() => Promise<void>) => {
  const store = useStore()

  return useCallback(() => waitForQuoteSyncIdle(store), [store])
}
